import { Skeleton } from "components/ui/skeleton";
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuSkeleton,
} from "components/ui/sidebar";

// Mirrors SidebarNavCollection's expanded layout — group title, the settings gear
// when the user can manage the group, then the item rows — so the navigation does
// not shift when the real rows arrive.
export const SidebarNavCollectionSkeleton = ({
  label,
  hasManage = false,
  rows = 3,
}) => (
  <SidebarGroup aria-busy="true" aria-label={`Loading ${label}`}>
    <div aria-hidden className="tw:flex tw:h-8 tw:items-center tw:px-2">
      <Skeleton className="tw:h-4 tw:w-20" />
    </div>
    {hasManage && (
      <Skeleton
        aria-hidden
        className="tw:absolute tw:top-3.5 tw:right-3 tw:size-5"
      />
    )}
    <SidebarMenu aria-hidden>
      {Array.from({ length: rows }, (_, index) => (
        <SidebarMenuItem key={index}>
          <SidebarMenuSkeleton showIcon />
        </SidebarMenuItem>
      ))}
    </SidebarMenu>
  </SidebarGroup>
);
